module.exports = __webpack_public_path__ + "img/othertit.755cf8a9.png";